import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { IProps as IMainProps } from './IProps';
import { IUseMenu } from './IUseMenu';
import useDictionary from '@ui/hooks/useDictionary';

interface IProps
    extends Pick<
        IMainProps,
        'onHoverStart' | 'onHoverStop' | 'button' | 'tooltip' | 'label'
    > {
    ref?: React.MutableRefObject<any>;
    onClick: IUseMenu['onOpen'];
    onKeyDown?: React.KeyboardEventHandler;
}

const Component: React.FC<IProps> = ({
    button,
    label,
    tooltip,
    onClick,
    onKeyDown,
    onHoverStart,
    onHoverStop,
}) => {
    const getWord = useDictionary();

    if (!button) {
        return (
            <Button className="menu__btn" variant="text" onClick={onClick}>
                <Typography className="menu__btn-text" variant="body1">
                    {getWord(label)}
                </Typography>
            </Button>
        );
    } else {
        const btn = (
            <IconButton
                className="menu__btn"
                aria-label={getWord(label)}
                onClick={onClick}
                onKeyDown={onKeyDown}
            >
                {button}
            </IconButton>
        );

        if (tooltip) {
            return (
                <Tooltip
                    classes={{
                        popper: 'manu__tooltip-popper',
                        tooltip: 'menu__tooltip',
                    }}
                    title={getWord(label)}
                    placement="top"
                    onTouchStartCapture={onHoverStart}
                    onTouchEndCapture={onHoverStop}
                    onMouseOver={onHoverStart}
                    onMouseOut={onHoverStop}
                    onMouseEnter={onHoverStart}
                    onFocus={onHoverStart}
                    onMouseLeave={onHoverStop}
                    onBlur={onHoverStop}
                >
                    <IconButton
                        className="menu__btn"
                        onClick={onClick}
                        onKeyDown={onKeyDown}
                    >
                        {button}
                    </IconButton>
                </Tooltip>
            );
        } else {
            return <>{btn}</>;
        }
    }
};

export const MenuButton = React.memo(Component);
